export const environment = {
  production: true,
  url: 'https://servi2.tuten.cl'
};
